module.exports = __webpack_public_path__ + "/login_ui/img/dz-72f4e712bfb5ee6fd231497225730021.svg";